import React from 'react';
import PropTypes, { nominalTypeHack } from 'prop-types';
import { NavLink } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import {withRouter} from 'react-router-dom'
import BackButtonComponent from './backButton.component';
import { version } from '../../../package.json';
import { Greetings } from 'aws-amplify-react';

/* eslint-disable */

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  background: {
    background: 'radial-gradient(at top, #49b2ed, #1183e6)',
    boxShadow: 'none',
  },
  logo: {
    width: '50px',
    verticalAlign: 'middle',
    padding: '10px 10px 10px 0px',
  },
  flex: {
    flex: 1,
  },
  linkStyle: {
    textDecoration: 'none',
    color: '#fff',
  },
  linkStyleLeft: {
    float: 'right',
    textDecoration: 'none',
    color: '#fff',
  },
  right: {
    textDecoration: 'none',
    float: 'left',
    color: '#fff',
  },
  appversion: {
    position: 'fixed',
    margin: '0',
    padding: '0 5px',
    fontSize: '13px',
    left: '0',
    bottom: '0',
    zIndex: '9999',
  },
});

const awsTheme = {
  navBar: {
    background: 'none',
    border: 'none',
    color: 'white',
  },
  navButton: {
    'background-color': '#0a6eb5',
    border: 'none',
    'border-radius': '4px',
    padding: '10px',
    'font-weight': 'bold',
    'font-size': '0.9em'
  }
}
const HeaderComponent = ({ classes,history,projectView,title }) => (
  <div className={classes.root}>
    <AppBar className={classes.background} position="static">
      <Toolbar>
        <BackButtonComponent url={projectView?'/': ''} />
        <Typography variant="h6" align="center" className={classes.flex}>
          <NavLink className={classes.linkStyle} to='/'>
            {/* <img className={classes.logo} src="/favicon.ico" alt="Logo" /> */}
            <span>{title?title:'This To That'}</span>
          </NavLink>
        </Typography>
        <Typography>
          <Greetings usernameAttributes={"email"} theme={awsTheme}/>
        </Typography>
        <NavLink className={classes.linkStyle} to="/help">
          <IconButton>
            <Icon className={classes.linkStyleLeft}>help</Icon>
          </IconButton>
        </NavLink>
      </Toolbar>
    </AppBar>
    <a href="javascript:(function(){let deg=0;document.documentElement.style.transitionDuration='3s';setInterval(()=>{deg=deg===360?0:deg+6;document.documentElement.style.filter=`hue-rotate(${deg}deg)`},3000)})()">
      <Typography className={classes.appversion} variant="caption" gutterBottom >
        v{version}
      </Typography>
    </a>
  </div>
);

HeaderComponent.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  projectView: PropTypes.bool,
  title: PropTypes.string
  /* eslint-enable */
};

export default withRouter(withStyles(styles)(HeaderComponent));
